import React from 'react'
import ReactDOM from 'react-dom/client'
import HomeApp from './HomeApp'
import '@/shared/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <HomeApp />
)

